<template>
	<div
		class="g-block-divider-dashed-dense g-block-divider-padding"
		:class="{
			'g-block-divider-dashed-dense--edit': editable,
			'is-active': editable && active,
			'g-block-divider-dashed-dense--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<span
			class="g-block-divider-dashed-dense__line"
			:style="{ color: themeColor }"
			aria-hidden="true"
		></span>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerDashedDense',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';
	@import '../shared/dividerPattern.less';

	.g-block-divider-dashed-dense {
		.divider-block-edit-shell();
	}

	.g-block-divider-dashed-dense__line {
		.divider-dash-line(2px, 6px, 4px);
	}

	.g-block-divider-dashed-dense--h5 {
		.g-block-divider-dashed-dense__line {
			.divider-dash-line--h5(0.04rem, 0.12rem, 0.08rem);
		}
	}
</style>
